var map = {
	"./APEDA (1).jpg": 7993,
	"./APEDA (2).jpg": 9360,
	"./APEDA (3).jpg": 131,
	"./APEDA-Logo.png": 3323,
	"./BioGrowth_Cert.jpg": 8452,
	"./BioGrowth_Logo.png": 6623,
	"./FSSAI_Cert (1).jpg": 3857,
	"./FSSAI_Cert (2).jpg": 3608,
	"./FSSAI_Cert (3).jpg": 955,
	"./FSSAI_Cert (4).jpg": 7706,
	"./FSSAI_Cert (5).jpg": 6053,
	"./FSSAI_Cert (6).jpg": 9436,
	"./FSSAI_Cert (7).jpg": 5455,
	"./FSSAI_Cert (8).jpg": 6510,
	"./FSSAI_Logo.png": 5904,
	"./GVT_Cert (1).jpg": 3856,
	"./GVT_Cert (2).jpg": 9305,
	"./GVT_Logo.png": 5901,
	"./RCMC (1).jpg": 8279,
	"./RCMC_Logo.jpg": 3191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;